const healthcampaigns = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Health Campaigns",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Campaigns",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Campaigns",
                submit_url: "/api/categories/$currentCategoryId/pages",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Campaigns Title",
                    placeholder: "Enter Campaigns Title",
                    required: true,
                    info: true,
                    character_count: 100,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  date: "",
                  featured: false,
                  media_type: "Image",
                  url: "",
                  image_url: "",
                  video_url: "",
                  media: false,
                  image_preview: "",
                  schedule: false,
                  schedule_input: [],
                },
              },
            },
            children: [
              {
                type: "newsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Select Campaigns",
                  type: "list",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                  isGlobal: false,
                  featuredIcon_position: "left",
                  global: {
                    label: "Global Update",
                    type: "list",
                    info: true,
                    size: "4",
                    style:
                      "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                    class: "p-0 pt-3 pr-3",
                    load_url: "/api/categories/$currentCategoryId/pages",
                    draggable: true,
                    children: [],
                  },
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Campaigns Title",
                      placeholder: "Enter Campaigns Title",
                      required: true,
                      info: true,
                      character_count: 100,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    date: {
                      type: "date",
                      label: "Date",
                      placeholder: "Enter Date",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    featured: {
                      type: "toggle",
                      label: "Featured",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      featuredIcon: true,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                    media: {
                      type: "toggle",
                      label: "Media",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    media_type: {
                      type: "select",
                      label: "Type",
                      placeholder: "Select Upload Option",
                      displayOn: "media",
                      displayOnValue: "true",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["None", "Image"],
                    },
                    image_url: {
                      type: "imgSelect",
                      label: "Image",
                      placeholder: "Select Image",
                      displayOn: "media_type",
                      displayOnValue: "Image",
                      displayOn2: "media",
                      displayOnValue2: "true",
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    video_url: {
                      type: "vidText",
                      label: "Video URL",
                      placeholder: "Enter Video URL",
                      displayOn: "media_type",
                      displayOnValue: "Video",
                      displayOn2: "media",
                      displayOnValue2: "true",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    image_preview: {
                      type: "imgPreview",
                      label: "",
                      placeholder: "",
                      displayOn: "media_type",
                      displayOnValue: "Image",
                      displayURL: "image_url",
                      displayOn2: "media",
                      displayOnValue2: "true",
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    // schedule: {
                    //   type: "toggle",
                    //   label: "Schedule",
                    //   placeholder: "",
                    //   required: false,
                    //   info: true,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    // schedule_input: {
                    //   type: "schedulerinput",
                    //   label: " ",
                    //   placeholder: "",
                    //   required: false,
                    //   info: false,
                    //   character_count: 0,
                    //   displayOn: "schedule",
                    //   displayOnValue: "true",
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    // hr4: {
                    //   type: "hr",
                    //   size: "12",
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Campaigns Title",
                      placeholder: "Enter Campaigns Title",
                      required: true,
                      info: true,
                      character_count: 100,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { healthcampaigns };
